import "./styles/main.css";
import { Router } from "./shared/router/Router.js";
import { establecerSesion, permisosAsignados, logout } from "./shared/services/LcapiiService.js";
import { Sesion } from "./shared/utils/Sesion.js";
import { Navbar } from "./shared/components/navbar/Navbar.js";

const initApp = async () => {
  if (new URLSearchParams(location.search).has("s")) {
    logout();
    return;
  }
  const ok = await establecerSesion();
  if (!ok) return;

  Sesion.permisos = await permisosAsignados();
  if (!Sesion.puedeIngresar()) {
    Navbar.renderSinAcceso();
    return;
  }

  const router = new Router();
  router.init();
};

document.addEventListener("DOMContentLoaded", initApp);
